import aliases from "./time-zone-aliases.generated.json" with { type: "json" };

const links = new Map<string, string>(Object.entries(aliases));

/** Resolve IANA backward links even when Intl preserves the supplied alias. */
export function canonicalTimeZone(zone: string): string {
  const canonical = links.get(zone) ?? zone;
  try {
    const resolved = new Intl.DateTimeFormat("en-US", { timeZone: canonical }).resolvedOptions()
      .timeZone;
    return links.get(resolved) ?? resolved;
  } catch {
    return canonical;
  }
}
